import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";
import Minibar from '../../../components/navbar/Minibar.js';
import ReportSystem from './ReportSystem.js';
import ReportBill from './ReportBill.js';

function HistoricalSiteReport(props) {
    const location = useLocation();
    const [submenu_root, setSubmenu_root] = useState('-');

    useEffect(() => {
        if (location.pathname.search("/historical/report/system") > -1) {
            setSubmenu_root('System Report')
        }
        if (location.pathname.search("/historical/report/bill") > -1) {
            setSubmenu_root('Billing Report')
        }
    }, [location]);

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Historical Tracking"}
                submenu_root={"Historical Site"}
                submenu_root2={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0">
                    <Routes>
                        <Route path="/system"
                            element={
                                <ReportSystem
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={true}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></ReportSystem>} />
                        <Route path="/bill"
                            element={
                                <ReportBill
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                    iscenter={true}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></ReportBill>} />
                    </Routes>
                </div>
            </div>
        </section>
    )
}
export default HistoricalSiteReport